import S from "sanctuary";
import { PAYMENT_STATUSES } from "@/sanctuary/typedefs";

const negativeAmountStatusList = [
  PAYMENT_STATUSES.REFUNDED,
  PAYMENT_STATUSES.ACH_RETURN,
  PAYMENT_STATUSES.CHARGEBACK,
];

export const getAmountByStatus = (amount, status, originalPaymentId = null) =>
  S.isJust(S.find((n) => S.equals(n)(status))(negativeAmountStatusList)) ||
  (originalPaymentId > 0 && S.equals(PAYMENT_STATUSES.FAILED)(status))
    ? `-$${amount}`
    : `$${amount}`;
